import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { bucketlink2 } from '../../config/fire-conf';
import { nftFirebaseStorage } from '../../config/firebaseStorage';
import Link from 'next/link';
import { makeStyles } from '@material-ui/core/styles';
import CheckoutDialog from './CheckoutDiaolg';
import { Alert, AlertTitle } from '@material-ui/lab';
import Collapse from '@material-ui/core/Collapse';
import { getMaxNftSize } from '../../services/common-query';
import { cyrb53 } from '../../helpers/strToHash';
import ArtistCreationDialog from './ArtistCreationDialog';
import CreateNewCollectionDialog from '../Dialog/CreateNewCollectionDialog';

import NftDetailStep from './NftDetailStep';
import NftSellingDetailsStep from './NftSellingDetailsStep';
import UploadFilesStep from './UploadFilesStep';
// import MinterDetailsStep from "./MinterDetailsStep";
import TermsStep from './TermsStep';
import ArtistDetailsStep from './ArtistDetailsStep';
import { ref, uploadBytes } from 'firebase/storage';

import { Steps } from 'antd';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  where,
  writeBatch,
  setDoc,
  Timestamp,
  arrayUnion,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

const path = require('path');
const { Step } = Steps;
let maxNftSize = {
  val: 0,
  mb: 0,
};
const steps = [
  {
    title: 'MusicArtists details ',
    content: 'First-content',
  },
  {
    title: 'NFT details',
    content: 'Second-content',
  },
  {
    title: 'NFT royalty details',
    content: 'Third-content',
  },
  {
    title: 'Upload files',
    content: 'Last-content',
  },
  // {
  //   title: "Minter details",
  //   content: "Last-content",
  // },

  // {
  //   title: 'Terms',
  //   content: 'Last-content',
  // },
];

export default function NftDetails(props) {
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const userWalletRedux = useSelector((state) => state.walletReducer);

  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);
  const [imageFile, setimageFile] = useState([]);
  const [audioCoverFile, setaudioCoverFile] = useState([]);
  const [audioCoverFileFull, setaudioCoverFileFull] = useState([]);

  const [sampleAudioFile, setsampleAudioFile] = useState([]);
  const [audioFileNames, setaudioFileNames] = useState([]);
  const [renameDialogState, setrenameDialogState] = useState(false);
  const [renameAudioFileName, setrenameAudioFileName] = useState('');

  const [imageFullFile, setimageFullFile] = useState([]);
  const [loadingMintBtn, setloadingMintBtn] = useState(false);

  const [nftDetails, setnftDetails] = useState({
    schemaId: 'Schema STAS Coupon',
    tokenId: '',
    tickerSymbol: '',
    price: '',
    activeInMarketPlace: false,
    thumbnailDesc: '',
    isMultiple: false,
    minBiddingPrice: '',
    auctionTimePeriod: '24h',
    musicArtist: '',
    tokenName: '', //title
    category: 'Select category...',
    nftQuantity: 1,
    collection: '',
    tokenDescription: '',
    royalty: '10',
    isAgreeService: true,
    terms:
      'Each MusicArt NFT is a digital token that represents your ownership of that particular item (which will continue until you sell or transfer it to somebody else). Your ownership of the MusicArt NFT will be forever associated with that item even after you transfer or sell it, as part of the permanent ledger of ownership that will follow that item. Please note that ownership of a MusicArt NFT does not bestow ownership in the intellectual property underlying the MusicArt NFT, other than the limited license that is granted to you via your purchase (which does not contain any rights to make any commercial use of the MusicArt NFT or any element therein, including without limitation by selling copies or derivative or merchandised works based on or associated with the MusicArt NFT in any media). The limited rights granted to you will end upon sale or transfer of the MusicArt NFT. Your ownership is of only the MusicArt NFT, not the underlying artwork and such ownership gives you no right to do anything which might disparage the original artist’s reputation, or advertise or promote any other item or service, or use or display the MusicArt NFT in a manner that associates any other product or service with the MusicArt NFT or the original artist. The original Artist reserves all intellectual property rights in the MusicArt NFT, including without limitation the right to copy, create derivative art works, display, perform, and/or distribute the MusicArt NFT.',
    governingLaw: 'England and Wales',
    artistId: null,
    artistName: '',
    nftType: 'Image',
    audioType: 'Single',
    editionType: 'Limited Edition',
    openEdition: null,

    //social links
    spotify: '',
    appleMusic: '',
  });
  const [selectedArtist, setSelectedArtist] = useState({});

  const [sellerDetails, setsellerDetails] = useState({
    name: '',
    email: '',
    bio: '',
    facebook: '',
    instagram: '',
    medium: '',
    tiktok: '',
    twitter: '',
    followers: 0,
    following: 0,
  });
  const [imagesUploadData, setimagesUploadData] = useState({
    stasTokenImgArr250_full: [],
    stasTokenImgArr1500_full: [],
    stasTokenImgArr10000_full: [],
  });
  const [backgroundImage, setbackgroundImage] = useState([]);
  const [profileImage, setprofileImage] = useState([]);
  const [loadingUpdateBtn, setloadingUpdateBtn] = useState(false);

  //
  const [nftCreationFee, setnftCreationFee] = useState(10);
  const [checkoutDialogState, setcheckoutDialogState] = useState(false);
  const [sellerProfile, setsellerProfile] = useState(null);
  const [alertState, setalertState] = useState(true);
  const [sellerCollections, setsellerCollections] = useState([]);
  const [collectionDialogState, setcollectionDialogState] = useState(false);
  const [nftSetupFee, setnftSetupFee] = useState(0);

  const [formStep, setFormStep] = useState(0);
  const [artistDialogState, setartistDialogState] = useState(false);
  const [artistList, setartistList] = useState([]);

  const [additionalNftFee, setadditionalNftFee] = useState(0);
  const [additionalMusicNftFee, setadditionalMusicNftFee] = useState(0);

  const next = () => {
    setFormStep(formStep + 1);
    window.scrollTo({
      top: 150,
      left: 0,
      behavior: 'smooth',
    });
  };

  const prev = () => {
    setFormStep(formStep - 1);
    window.scrollTo({
      top: 150,
      left: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    if (sellerProfile) {
      getSellerProfile();
    }
  }, [sellerProfile]);

  const getSellerProfile = async () => {
    let sellerObj = sellerProfile;
    setsellerDetails({ ...sellerObj });

    if (sellerObj && sellerObj.thumbnailImage) {
      let arr = [];
      arr.push({
        uid: 'img-seller-background',
        name: 'image-bg.png',
        status: 'done',
        url: sellerObj.thumbnailImage,
        uploaded: true,
      });
      setbackgroundImage(arr);
    } else {
      setbackgroundImage([]);
    }

    if (sellerObj && sellerObj.photoUrl) {
      let arr = [];
      arr.push({
        uid: 'img-seller-profile',
        name: 'image-profile.png',
        status: 'done',
        url: sellerObj.photoUrl,
        uploaded: true,
      });
      setprofileImage(arr);
    } else if (userDataRedux && userDataRedux.photoURL) {
      setprofileImage([
        {
          uid: 'img-seller-profile',
          name: 'image-profile.png',
          status: 'done',
          url: userDataRedux.photoURL,
          uploaded: true,
        },
      ]);
    } else {
      setprofileImage([]);
    }
  };

  useEffect(() => {
    getMaxImgSize();
  }, []);

  const getMaxImgSize = async () => {
    maxNftSize = await getMaxNftSize();
  };

  useEffect(() => {
    if (userDataRedux) {
      let modifiedObj = {
        ...nftDetails,
      };
      if (userDataRedux.email) {
        // modifiedObj.issuerEmail = userDataRedux.email;
        // modifiedObj.ownerEmail = userDataRedux.email;
      }

      setnftDetails(modifiedObj);

      getSellerData(userDataRedux.uid);
      getSellerCollections();
      // getMinterBackupDetails();
    }
  }, [userDataRedux]);

  useEffect(() => {
    let modifiedObj = { ...nftDetails };
    if (nftDetails.nftQuantity > 1) {
      modifiedObj.isMultiple = true;
    } else {
      modifiedObj.isMultiple = false;
    }

    setnftDetails(modifiedObj);
  }, [nftDetails.nftQuantity]);

  useEffect(() => {
    getNftCreationFee();
    getArtsitList();
  }, []);

  const [size, setSize] = useState('0');
  let IsSmallScreen = 540;

  useEffect(() => {
    handleSize();
    window.addEventListener('resize', handleSize);
    return () => {
      window.removeEventListener('resize', handleSize);
    };
  }, []);

  const handleSize = () => {
    setSize(window.innerWidth);
  };

  const getArtsitList = async () => {
    const q = query(
      collection(firebaseFireStore, 'musicartArtists'),
      where('adminState', '==', 'APPROVED'),
      orderBy('followers', 'desc'),
    );

    let snap = await getDocs(q);

    if (snap.empty) {
      return;
    }

    let dataArr = [];
    snap.forEach((doc, i) => {
      dataArr.push({ ...doc.data(), artistId: doc.id });
    });
    setartistList(dataArr);
  };

  const getNftCreationFee = async () => {
    let snap1 = await getDoc(
      doc(firebaseFireStore, 'MusicArtGlobalVariables', `nftCreationFee`),
    );

    let snap2 = await getDoc(
      doc(firebaseFireStore, 'MusicArtGlobalVariables', `additionalNftFee`),
    );

    let snap3 = await getDoc(
      doc(
        firebaseFireStore,
        'MusicArtGlobalVariables',
        `additionalMusicNftFee`,
      ),
    );

    if (snap1.exists && snap1.data() && snap1.data().fee) {
      let fee = Number(snap1.data().fee);
      setnftSetupFee(fee);

      setnftCreationFee(fee);
    }
    if (snap2.exists && snap2.data() && snap2.data().fee) {
      let fee = Number(snap2.data().fee);
      setadditionalNftFee(fee);
    }
    if (snap3.exists && snap3.data() && snap3.data().fee) {
      let fee = Number(snap3.data().fee);
      setadditionalMusicNftFee(fee);
    }
  };

  const getSellerCollections = async () => {
    const q = query(
      collection(firebaseFireStore, 'musicartCollections'),
      where('creator', '==', userDataRedux.uid),
    );

    let collectionsData = await getDocs(q);

    if (collectionsData.empty) {
      return null;
    } else {
      let arr = [];
      collectionsData.forEach((doc) => {
        arr.push(doc.data());
      });
      setsellerCollections(arr);
    }
  };

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('ok');
    }, 0);
  };

  const onChangeImage = async ({ fileList: newFileList, file: file }) => {
    let pass = true;
    newFileList.map((ele, index) => {
      if (ele && ele.size > maxNftSize.val) {
        pass = false;
      }
    });

    if (pass) {
      if (nftDetails.nftType === 'Image' && !file.type.includes('image')) {
        toast.error(`Invalid file type`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        return null;
      } else if (nftDetails.nftType === 'Video' && file.type !== 'video/mp4') {
        toast.error(`Invalid file type`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        return null;
      }

      if (nftDetails.nftType === 'Audio') {
        if (newFileList.length > imageFile.length) {
          //update file name
          setrenameAudioFileName(
            file.name ? path.parse(file.name).name : 'Track',
          );
          setrenameDialogState(true);
        } else {
          //update arr
          let nArr = [];
          newFileList.map((file) => {
            nArr.push(file.name);
          });
          setaudioFileNames(nArr);
        }
      }

      if (file && file.uid) {
        if (file.status === 'uploading') {
          setimageFullFile([...imageFullFile, file]);
        } else if (file.status === 'removed') {
          let modifiedArr = [...imageFullFile];
          let rmIndex = modifiedArr.findIndex((x) => x.uid === file.uid);
          if (rmIndex !== -1) {
            modifiedArr.splice(rmIndex, 1);
            setimageFullFile([...modifiedArr]);

            // if (nftDetails.nftType === 'Audio') {
            //   let filenamesArr = [...audioFileNames];
            //   filenamesArr.splice(rmIndex, 1);
            //   setaudioFileNames([...filenamesArr]);
            // }
          }
        } else if (
          file.type.includes('gif') ||
          file.type.includes('video') ||
          file.type.includes('audio')
        ) {
          let cArr = [...imageFullFile, file];
          setimageFullFile(cArr);
        }
      }

      setimageFile(
        newFileList.map((file) => {
          return { ...file, status: 'done' };
        }),
      );
    } else {
      toast.error(`Image must be smaller than ${maxNftSize.mb} MB`, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  const onChangeAudioCoverImage = async ({
    fileList: newFileList,
    file: file,
  }) => {
    let pass = true;
    newFileList.map((ele, index) => {
      if (ele && ele.size > maxNftSize.val) {
        pass = false;
      }
    });

    if (pass) {
      if (!file.type.includes('image')) {
        toast.error(`Invalid file type`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        return null;
      }

      if (file && file.uid) {
        if (file.status === 'uploading') {
          setaudioCoverFileFull([...audioCoverFileFull, file]);
        } else if (file.status === 'removed') {
          let modifiedArr = [...audioCoverFileFull];
          let rmIndex = modifiedArr.findIndex((x) => x.uid === file.uid);
          if (rmIndex !== -1) {
            modifiedArr.splice(rmIndex, 1);
            setaudioCoverFileFull([...modifiedArr]);
          }
        } else if (file.type.includes('gif')) {
          let cArr = [...audioCoverFileFull, file];
          setaudioCoverFileFull(cArr);
        }
      }

      setaudioCoverFile(
        newFileList.map((file) => {
          return { ...file, status: 'done' };
        }),
      );
    } else {
      toast.error(`Image must be smaller than ${maxNftSize.mb} MB`, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  const onChangeSampleAudioFile = async ({
    fileList: newFileList,
    file: file,
  }) => {
    let pass = true;
    newFileList.map((ele, index) => {
      if (ele && ele.size > maxNftSize.val) {
        pass = false;
      }
    });

    if (pass) {
      if (!file.type.includes('audio')) {
        toast.error(`Invalid file type`, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        return null;
      }

      setsampleAudioFile(
        newFileList.map((file) => {
          return { ...file, status: 'done' };
        }),
      );
    } else {
      toast.error(`Image must be smaller than ${maxNftSize.mb} MB`, {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }

    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow.document.write(image.outerHTML);
  };

  const mintNft = async (e) => {
    e.preventDefault();
    if (!nftDetails.isAgreeService) {
      toast.error('First check the Terms of Service box.', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    } else {
      setloadingMintBtn(true);

      try {
        setcheckoutDialogState(true);
        setloadingMintBtn(false);
      } catch (err) {
        toast.error(err.message, {
          position: 'bottom-left',
          autoClose: 15000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        setloadingMintBtn(false);
      }
    }
  };

  const getSellerData = async (collectorId) => {
    let sellerLData = await getDoc(
      doc(firebaseFireStore, 'musicartSellers', collectorId),
    );
    if (sellerLData.exists) {
      setsellerProfile({ ...sellerLData.data() });
    }
  };

  // const getMinterBackupDetails = async () => {
  //   let minterLData = await firebase
  //     .fires/tore()
  //     .doc("musicartBackupMinterDetails/" + userDataRedux.uid)
  //     .get();

  //   if (minterLData.exists) {
  //     let dataObj = minterLData.data();
  //     setnftDetails({
  //       ...nftDetails,
  //       issuerProvince: dataObj.province ? dataObj.province : "",
  //       issuerzipCode: dataObj.zipCode ? dataObj.zipCode : "",
  //       issuerCity: dataObj.city ? dataObj.city : "",
  //       issuerContact: dataObj.contact ? dataObj.contact : "",
  //       issuerCountry: dataObj.country ? dataObj.country : "",
  //     });

  //     setminterDetails({
  //       ...minterDetails,

  //       issuerFirstName: dataObj.firstName ? dataObj.firstName : "",
  //       issuerLastName: dataObj.lastName ? dataObj.lastName : "",
  //       issuerstreetAddress: dataObj.streetAddress1
  //         ? dataObj.streetAddress1
  //         : "",
  //       issueraddressLine2: dataObj.streetAddress2
  //         ? dataObj.streetAddress2
  //         : "",
  //     });
  //   }
  // };

  const onChangeNftDetailsField = (e, isValue, value) => {
    setnftDetails({
      ...nftDetails,
      [e.target.name]: isValue ? value : e.target.value,
    });
  };

  const onClickRoyalty = (e, isValue, value) => {
    setnftDetails({
      ...nftDetails,
      [e.target.name]: isValue ? value : e.target.value,
    });
  };

  const onUpdateNFTtype = (type) => {
    setnftDetails({
      ...nftDetails,
      nftType: type,
    });
    setimageFile([]);
    setaudioFileNames([]);
  };

  const onUpdateEditiontype = (type) => {
    setnftDetails({
      ...nftDetails,
      editionType: type,
    });
  };

  const reappeal = async () => {
    try {
      let batch = writeBatch(firebaseFireStore);

      let tokenSummaryRef = doc(
        firebaseFireStore,
        'musicartSellers',
        userDataRedux.uid,
      );

      batch.update(tokenSummaryRef, {
        adminState: 'PENDING',
      });

      batch.commit();

      toast.success('Reappeled successfully!', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });

      setsellerProfile({ ...sellerProfile });
    } catch (err) {
      console.log('err', err);
    }
  };

  const renderSteps = () => {
    switch (formStep) {
      case 1: {
        return (
          <NftDetailStep
            formStep={formStep}
            steps={steps}
            onChange={onChangeNftDetailsField}
            clearField={(key) => {
              setnftDetails({
                ...nftDetails,
                [key]: '',
              });
            }}
            nftDetails={nftDetails}
            setnftDetails={setnftDetails}
            nftCreationFee={nftCreationFee}
            setnftCreationFee={setnftCreationFee}
            isMultiple={nftDetails.isMultiple}
            setcollectionDialogState={setcollectionDialogState}
            sellerCollections={sellerCollections}
            bsvRate={bsvRate}
            next={next}
            prev={prev}
            nftSetupFee={nftSetupFee}
            additionalNftFee={additionalNftFee}
            additionalMusicNftFee={additionalMusicNftFee}
            onUpdateNFTtype={onUpdateNFTtype}
            onUpdateEditiontype={onUpdateEditiontype}
          />
        );
      }
      case 2: {
        return (
          <NftSellingDetailsStep
            onClickRoyalty={onClickRoyalty}
            nftDetails={nftDetails}
            setnftDetails={setnftDetails}
            formStep={formStep}
            steps={steps}
            next={next}
            prev={prev}
            bsvRate={bsvRate}
          />
        );
      }
      case 3: {
        return (
          <UploadFilesStep
            imageFile={imageFile}
            audioFileNames={audioFileNames}
            setaudioFileNames={setaudioFileNames}
            dummyRequest={dummyRequest}
            onChangeImage={onChangeImage}
            loadingMintBtn={loadingMintBtn}
            onPreview={onPreview}
            formStep={formStep}
            steps={steps}
            next={next}
            prev={prev}
            showAlert={showAlert}
            nftDetails={nftDetails}
            onChange={onChangeNftDetailsField}
            onUpdateNFTtype={onUpdateNFTtype}
            audioCoverFile={audioCoverFile}
            setaudioCoverFile={setaudioCoverFile}
            setaudioCoverFileFull={setaudioCoverFileFull}
            onChangeAudioCoverImage={onChangeAudioCoverImage}
            onChangeSampleAudioFile={onChangeSampleAudioFile}
            sampleAudioFile={sampleAudioFile}
            setimageFile={setimageFile}
            renameDialogState={renameDialogState}
            setrenameDialogState={setrenameDialogState}
            renameAudioFileName={renameAudioFileName}
          />
        );
      }
      // case 4: {
      //   return (
      //     <MinterDetailsStep
      //       minterDetails={minterDetails}
      //       setminterDetails={setminterDetails}
      //       onChange={onChangeNftDetailsField}
      //       options={options}
      //       nftDetails={nftDetails}
      //       formStep={formStep}
      //       steps={steps}
      //       next={next}
      //       prev={prev}
      //       clearField={(key) => {
      //         setnftDetails({
      //           ...nftDetails,
      //           [key]: "",
      //         });
      //       }}
      //     />
      //   );
      // }

      // case 4: {
      //   return (
      //     <TermsStep
      //       nftDetails={nftDetails}
      //       onChange={onChangeNftDetailsField}
      //       loadingMintBtn={loadingMintBtn}
      //       showAlert={showAlert}
      //       formStep={formStep}
      //       steps={steps}
      //       next={next}
      //       prev={prev}
      //     />
      //   );
      // }

      default: {
        return (
          <ArtistDetailsStep
            nftDetails={nftDetails}
            onChange={onChangeNftDetailsField}
            showAlert={showAlert}
            formStep={formStep}
            steps={steps}
            next={next}
            prev={prev}
            setartistDialogState={setartistDialogState}
            artistList={artistList}
            setartistList={setartistList}
            userP2DetailsExist={props.userP2Detail}
            userP2Details={props.userDetail}
            setArtistId={(id, name) => {
              setnftDetails({
                ...nftDetails,
                artistId: id,
                artistName: name,
              });
            }}
            selectedArtist={selectedArtist}
            setSelectedArtist={setSelectedArtist}
          />
        );
      }
    }
  };

  let showAlert =
    sellerProfile &&
    userDataRedux &&
    userDataRedux.uid &&
    (!sellerProfile.adminState ||
      (sellerProfile.adminState &&
        (sellerProfile.adminState === 'PENDING' ||
          sellerProfile.adminState === 'REJECT')))
      ? true
      : false;

  console.log('audioCoverFileFull', audioCoverFileFull);
  return (
    <>
      {(() => {
        if (showAlert) {
          return (
            <Collapse in={alertState}>
              <div
                style={{
                  margin: '25px auto 10px auto ',
                }}
                className="alert-old-tran"
              >
                <Alert
                  severity={
                    sellerProfile.adminState === 'PENDING' ? 'info' : 'error'
                  }
                >
                  <AlertTitle>
                    {sellerProfile.adminState === 'PENDING'
                      ? ' You are unable to mint a new NFT. Your profile is in pending state!'
                      : ' You are unable to mint a new NFT. Your profile is rejected by MusicArt Team.'}
                  </AlertTitle>
                  {sellerProfile.adminState === 'PENDING' ? (
                    'MusicArt Team will got through your details and notify you.'
                  ) : (
                    <>
                      Rejection reason:{' '}
                      {sellerProfile.rejectionReason
                        ? sellerProfile.rejectionReason
                        : 'not provided'}
                      <br />
                      Please update your details from
                      <Link
                        prefetch={false}
                        href={
                          '/collector/' + userDataRedux.uid + '?tab=Settings'
                        }
                      >
                        <a>
                          <strong className="cursor-pointer reappeal_btn">
                            {' '}
                            here{' '}
                          </strong>
                        </a>
                      </Link>
                      and reapply -{' '}
                      <strong
                        className="cursor-pointer reappeal_btn"
                        onClick={reappeal}
                      >
                        Reappeal
                      </strong>
                    </>
                  )}
                </Alert>
              </div>
            </Collapse>
          );
        }
      })()}
      <div className="steps-content-wrapper">
        <div className="steps_content_list_box lg:pl-0 md:pl-0 pl-3">
          <Steps
            current={formStep}
            direction={IsSmallScreen <= size ? 'vertical' : ' horizontal'}
            size="small"
            responsive={IsSmallScreen <= size ? true : false}
          >
            {steps.map((item) => (
              <Step
                key={item.title}
                title={IsSmallScreen <= size ? item.title : ''}
                className="sign__title step_title-box"
              />
            ))}
          </Steps>
        </div>
        <div className="steps-content ">
          <form
            id="minting-form"
            onSubmit={mintNft}
            className="sign__form_form sign__form--mint sign__form_form_mint mint_sign_form_custom"
          >
            {renderSteps()}
          </form>
        </div>
      </div>
      <div className="steps-action">{/* {renderStepperActions()} */}</div>
      <CheckoutDialog
        // minterDetails={minterDetails}
        // setminterDetails={setminterDetails}
        imagesUploadData={imagesUploadData}
        setimagesUploadData={setimagesUploadData}
        dialogState={checkoutDialogState}
        setdialogState={setcheckoutDialogState}
        nftCreationFee={nftCreationFee}
        bsvRate={bsvRate}
        imageFile={imageFile}
        setimageFile={setimageFile}
        imageFullFile={imageFullFile}
        setimageFullFile={setimageFullFile}
        nftDetails={nftDetails}
        setnftDetails={setnftDetails}
        isMultiple={nftDetails.isMultiple}
        nftSetupFee={nftSetupFee}
        sampleAudioFile={sampleAudioFile}
        audioCoverFile={audioCoverFile}
        audioCoverFileFull={audioCoverFileFull}
        setaudioCoverFileFull={setaudioCoverFileFull}
        audioFileNames={audioFileNames}
        setaudioFileNames={setaudioFileNames}
      />
      <CreateNewCollectionDialog
        dialogState={collectionDialogState}
        setdialogState={setcollectionDialogState}
        setCollectionVal={(val) => {
          setnftDetails({
            ...nftDetails,
            collection: val,
          });
        }}
        sellerCollections={sellerCollections}
        setsellerCollections={setsellerCollections}
        userId={userDataRedux && userDataRedux.uid ? userDataRedux.uid : null}
      />
      <ArtistCreationDialog
        dialogState={artistDialogState}
        setdialogState={setartistDialogState}
        artistList={artistList}
        setartistList={setartistList}
        setSelectedArtist={setSelectedArtist}
        setArtistId={(id, name) => {
          setnftDetails({
            ...nftDetails,
            artistId: id,
            artistName: name,
          });
        }}
      />
    </>
  );
}

const useStyles = makeStyles(() => ({
  selectEle: {
    minWidth: 150,
  },
}));
